import React, { useState } from "react";
import { makeStyles, Paper } from "@material-ui/core";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
// import { requestPassword } from "../../../api/authApi";
// import { REQUEST_PASSWORD_URL } from "../../../api/authApi";
import httpClientService from "../../../helpers/apiHelper";
import { actions } from "../redux/actions";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import { Spinner } from "react-bootstrap";
import Config from "../../../helpers/Config";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  select: {
    minWidth: 200,
  },
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(4),
    width: "400px",
  },
  input: {
    width: "250px",
  },
  alignCenter: {
    display: "flex",
    flexWrap: "no-wrap",
    alignItems: "center",
    padding: "5px 0 !important",
  },
  textField: {
    // marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  remark: {
    minWidth: "400px",
    minHeight: "150px",
  },
  spinnerFrame: {
    width: "336px",
    height: "153px",
  },
}));

const initialValues = {
  account: "",
};

function ForgotPassword(props) {
  const domin = Config.get("API_HOST");
  const classes = useStyles();
  const history = useHistory();
  // const { intl } = props;
  const [err, seterr] = React.useState("");
  // const [isRequested, setIsRequested] = useState(false);
  const [success, setSuccess] = React.useState("");
  const ForgotPasswordSchema = Yup.object().shape({
    account: Yup.string()
      .min(3, "最少3碼")
      .max(50, "最多50碼")
      .required("此為必填欄位"),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  //是否在讀取
  const [loading, setLoading] = useState(false);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      const account = values.account;
      const url = `${domin}/vendor/password/forget`;
      console.log("on submit");
      enableLoading();

      httpClientService("post", url, "tmp", { account: account })
        .then((res) => {
          console.log("res:", res.msg);
          if (!_.get(res, "result")) {
            console.log(_.get(res, "msg"));
            if (_.get(res, "msg") === ("查無此Token，請重新登入" || "此Token失效，請重新登入" || "登入失敗查無此Token，請重新登入")) {
              history.push("/logout");
            }
          }

          if (
            !_.get(res, "result") ||
            _.get(res, "msg") === "送出失敗, 無此帳號"
          ) {
            seterr(res.msg);
          } else {
            setSuccess(res.msg);
          }
          disableLoading();
        })
        .catch((err) => {
          console.log(err);
          seterr(err.toString());
          disableLoading();
        });
    },
  });

  return (
    <>
      {/* {isRequested && <Redirect to="/auth" />} */}
      {/* {!isRequested && ( */}
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <Paper className={classes.paper}>
            <div className="text-center mb-5 mb-lg-5">
              <div className="font-size-h1 text-center font-weight-bold">
                忘記密碼 ?
              </div>
              <div className="text-muted font-weight-bold">
                輸入帳號以變更密碼
              </div>
            </div>
            {success ? (
              <Alert severity="success" className="my-5">
                {success}
              </Alert>
            ) : err ? (
              <Alert severity="error" className="my-5">
                {err}
              </Alert>
            ) : (
              <></>
            )}

            {loading ? (
              <div
                className={`d-flex align-items-center justify-content-center ${classes.spinnerFrame}`}
              >
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <form
                onSubmit={formik.handleSubmit}
                className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
              >
                {formik.status && (
                  <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                    <div className="alert-text font-weight-bold">
                      {formik.status}
                    </div>
                  </div>
                )}
                <div className="form-group fv-plugins-icon-container m-0">
                  <input
                    placeholder="請輸入帳號"
                    className={`form-control loginiInput h-auto py-5 px-6 ${getInputClasses(
                      "account"
                    )}`}
                    name="account"
                    {...formik.getFieldProps("account")}
                  />
                  {formik.touched.account && formik.errors.account ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.account}
                      </div>
                    </div>
                  ) : (
                    <div className="pb-7"></div>
                  )}
                </div>
                <div className="form-group d-flex flex-wrap justify-content-between">
                  <button
                    id="kt_login_forgot_submit"
                    type="submit"
                    className="btn btn-primary font-weight-bold px-9 py-4 my-3 mr-4 ml-0"
                  >
                    確認
                  </button>
                  <Link to="/auth">
                    <button
                      type="button"
                      id="kt_login_forgot_cancel"
                      className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 ml-4 mr-0"
                    >
                      取消
                    </button>
                  </Link>
                </div>
              </form>
            )}
          </Paper>
        </div>
      {/* )} */}
    </>
  );
}

export default injectIntl(connect(null, actions)(ForgotPassword));
